import { render, staticRenderFns } from "./RouteCard.vue?vue&type=template&id=dde37eca&scoped=true"
import script from "./RouteCard.vue?vue&type=script&lang=js"
export * from "./RouteCard.vue?vue&type=script&lang=js"
import style0 from "./RouteCard.vue?vue&type=style&index=0&id=dde37eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde37eca",
  null
  
)

export default component.exports